export const PromoInfoFormFieldNames = {
    PromoType: 'promoType',
    TacticType: 'tacticType',
    FeatureQuality: 'featureQuality',
    DisplayQuality: 'displayQuality',
    OfferMethod: 'offerType',
    ManualOffer: 'manualOffer',
    PromoStartDate: 'promoStartDate',
    PromoEndDate: 'promoEndDate',
    CRAEndDate: 'craEndDate',
    CRAStartDate: 'craStartDate',
    status: 'status',
    FundingRequest: 'fundingRequest',
    ParNumber: 'parNumber',
    IsmCampaignId: 'ismCampaignId',
    ContractNumber: 'contractNumber',
    PromoName: 'name',
};

export const OPTIMIZATION_POLLING_INTERVAL = 12000;

export const LAST_UPDATED_POLLING_INTERVAL = 10000;

export const TPO_UI_LIMITS = {
    PPG_SELECTION: 50,
};

export const TpoMessages = {
    error: {
        FAILED_TO_SAVE: 'Failed to save promo details.',
        EDLP_PROMO_CRA_DATE: "'EDLP' requires Promo Dates to match CRA Dates exactly.",
        EDLP_PPG_QUARTER_SPAN: (miscMetric: string, scanMetric: string, ppgs: string[]) =>
            `The following PPGs cannot span quarters when ${miscMetric} or ${scanMetric} is greater than 0: [ ${ppgs.join(
                ', ',
            )} ]`,
        INVALID_VALUE: (metricName: string, invalidValue: any) => `${metricName} can't be ${invalidValue}`,
        NON_EDLP_PROMOTED_SRP_EXCEEDS: (violations: string[]) =>
            `The Promoted SRP for [${violations.join(
                ', ',
            )}] exceeds the EDLP SRP. Please adjust the pricing accordingly.`,
        MERCH_SHOULD_HAVE_MINIMUM_ONE_SPEND: 'Merchandising promotion should have at least one spend',
        TPO_ADJUSTED_BASE_UNITS_CANNOT_BE_NEGATIVE: (ppgNames: string[]) =>
            `TPO Base Units is negative for ${ppgNames.join(',')}`,
        INVALID_PROMO_DATE: "Promo dates can't be in the past",
    },

    success: {
        PROMO_CREATED: 'Promotion has been successfully created.',
        DATA_SAVED: 'Changes have been saved successfully.',
        BULK_UPLOAD_SUCCESS: (count: number) => `${count} records were updated successfully.`,
    },
    info: {
        CHANGES_ARE_BEING_SAVED: 'Your current changes are being saved. Please wait.',
        TRADE_RATE_EXCEEDS_50_INFO: (warnings: string[]) =>
            `Trade rate exceeds 50% of the list price for the following products: ${warnings.join(', ')}. `,
        NO_MATCHING_KPIS: 'No matching KPIs were found for the selected filters.',
        UNSAVED_CHANGES: 'You have unsaved changes. Proceed with caution.',
    },
};
